import React from 'react';
import Info from '../assets/images/InfoIcon.svg';

export default () => {
  return <img src={Info} alt="Information" />;
};
